import * as requestFromServer from './localidadCrud';
import { localidadSlice, callTypes } from './localidadSlice';

const { actions } = localidadSlice;

export const fetchLocalidades = queryParams => dispatch => {
    dispatch(actions.starCall({ callType: callTypes.list }));
        return requestFromServer
        .getLocalidades(queryParams)
        .then(response => {
            const localidades = response.data;
            dispatch(actions.localidadesFetched({ localidades }));
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data);
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};
